import { CID } from 'multiformats/cid';

export function parseCid(cid: string): CID {
  return CID.parse(cid);
}

export function normalizeCid(cid: string | CID): string {
  return typeof cid === 'string' ? parseCid(cid).toString() : cid.toString();
}
